module.exports = __webpack_public_path__ + "static/media/dark-tag-content.23a395b9.svg";